import React, { useState, useEffect, Suspense } from "react";
import {
  Modal,
  Box,
  Typography,
  IconButton,
  Button,
  Grid,
  Paper,
  TextField,
  Radio,
  useTheme,
  useMediaQuery,
  CircularProgress,
  responsiveFontSizes,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import AddIcon from "@mui/icons-material/Add";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import TroubleInPayment from "./TroubleInPayment";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import Checkbox from "@mui/material/Checkbox";

import axios from "axios";
import { toast } from "react-toastify";
import TransactionStatusModal from "./TransactionStatusModal";
import { useSelector } from "react-redux";
import RedeemNameMismatchModal from "./RedeemNameMismatchModal ";
import AadhaarTDSWarningModal from "./AadhaarTDSWarningModal";
import PanErrorModal from "./PanErrorModal";
import AddBankAccountModal from "./AddBankAccountModal";

const baseURL = "https://vjoneparivaar.com/api";

const WithdrawPointsModal = ({
  open,
  onClose,
  fosFinalReedemableBalance,
  getfosFinalReedemableBalance,
  handleClose,
  onSuccess,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "#fff",
    boxShadow: 24,
    borderRadius: 2,
    width: isMobile ? "80%" : "90%",
    maxWidth: 500,
    p: isMobile ? 2 : 4,
    maxHeight: "90vh",
    overflowY: "auto",
    fontFamily: "'Poppins', sans-serif",
  };

  // const [selectedMethod, setSelectedMethod] = useState("bank");
  const [selectedMethod, setSelectedMethod] = useState("upi");
  const [showAddAccountModal, setShowAddAccountModal] = useState(false);
  const [showTroubleModal, setShowTroubleModal] = useState(false);

  const [accountData, setAccountData] = useState({
    accountNumber: "",
    ifsc: "",
    bankName: "",
    branchName: "",
    upiId: "",
  });

  // console.log('accountdate =============>',accountData)
  const [savedAccounts, setSavedAccounts] = useState([]);
  const [selectedAccountIndex, setSelectedAccountIndex] = useState(null);

  // console.log("selectedAccountIndex ====> ", selectedAccountIndex);

  const [showStatusModal, setShowStatusModal] = useState(false);
  const [isSuccess, setIsSuccess] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);

  // const [transactionDetails,setTransactionDetails] = useState ()
  const [fosBankAccountsByFos, setFosBankAccountsByFos] = useState();
  const [transactionDetails, setTransactionDetails] = useState(null);
  const [upiId, setUpiId] = useState("");
  const [addBankAccountLoading, setAddBankAccountLoading] = useState(false);
  const [nameMismatchModal, setNameMismatchModal] = useState(false);
  const [nameInVJDB, setNameInVJDB] = useState("");
  const [nameAsPerBankUPI, setNameAsPerBankUPI] = useState("");

  const [aadhaarLinkedWithPan, setAadhaarLinkedWithPan] = useState("");
  const [panValid, setPanValid] = useState(false);
  const [showAadhaarModal, setShowAadhaarModal] = useState(false);
  const [aadhaarFlowLoading, setAadhaarFlowLoading] = useState(false);
  const [showPanErrorModal, setShowPanErrorModal] = useState(false);
  const [panErrorMessage, setPanErrorMessage] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [displayNameMismatchModal, setDisplayNameMismatchModal] =
    useState(false);
  const [transactionStatusToastMessage, setTransactionStatusToastMessage] =
    useState("");
  const [customerNameAsPerBankUPI, setCustomerNameAsPerBankUPI] =
    useState("N.A.");

  // console.log(upiId,'upiId===========>')

  const { fosId, email, name,contactNumber } = useSelector((state) => state.Auth.user);

//   const user = useSelector((state) => state.Auth.user);
// const { fosId, email, name, mobile, phone, phoneNumber, mobileNumber } = user;

// console.log('userrrrrrr-=========',user);

// // Check which one exists
// console.log({
//   mobile: user.mobile,
//   phone: user.phone,
//   phoneNumber: user.phoneNumber,
//   mobileNumber: user.mobileNumber
// });

  
  // console.log("fosId and Name =============>",fosId,name);

  //   setAadhaarFlowLoading(true);
  //   try {
  //     if (selectedMethod === "bank") {
  //       await fosReedemPointsIMPSTransaction();
  //     } else {
  //       await fosReedemPointsUpiTransaction();
  //     }

  //     setTimeout(() => {
  //       setIsSuccess(true);
  //       setAadhaarFlowLoading(false);
  //       setShowAadhaarModal(false);
  //       setTimeout(() => {
  //         onClose();
  //       }, 3000);
  //     }, 3000);
  //   } catch (error) {
  //     console.error("Redemption failed:", error);
  //     setTimeout(() => {
  //       setIsSuccess(false);
  //       setAadhaarFlowLoading(false);
  //       setShowAadhaarModal(false);
  //       setTimeout(() => {
  //         setShowStatusModal(false);
  //         onClose();
  //       }, 3000);
  //     }, 3000);
  //   }
  // };
  // const handleAadhaarModalProceed = async () => {
  //   setAadhaarFlowLoading(true);

  //   try {
  //     if (selectedMethod === "bank") {
  //       await fosReedemPointsIMPSTransaction(); // Shows TransactionStatusModal internally
  //     } else {
  //       await fosReedemPointsUpiTransaction();  // Shows TransactionStatusModal internally
  //     }

  //     setAadhaarFlowLoading(false);
  //     setShowAadhaarModal(false); // Hide Aadhaar modal
  //   } catch (error) {
  //     console.error("Redemption failed:", error);
  //     toast.error("Transaction failed. Please try again.");
  //     setAadhaarFlowLoading(false);
  //     setShowAadhaarModal(false);
  //   }
  // };
  // const handleAadhaarModalProceed = async () => {
  //   setAadhaarFlowLoading(true);
  //   try {
  //     if (selectedMethod === "bank") {
  //       await fosReedemPointsIMPSTransaction();
  //     } else {
  //       await fosReedemPointsUpiTransaction();
  //     }

  //     setTimeout(() => {
  //       setIsSuccess(true);
  //       setAadhaarFlowLoading(false);
  //       setShowAadhaarModal(false);
  //       setTimeout(() => {
  //         onClose(); // Close the Withdraw modal
  //       }, 3000);
  //     }, 3000);
  //   } catch (error) {
  //     console.error("Redemption failed:", error);
  //     toast.error("Transaction failed. Please try again.");
  //     setTimeout(() => {
  //       setIsSuccess(false);
  //       setAadhaarFlowLoading(false);
  //       setShowAadhaarModal(false);
  //       setTimeout(() => {
  //         setShowStatusModal(false);
  //         onClose();
  //       }, 3000);
  //     }, 3000);
  //   }
  // };

  //    const handleNoAadhaarLinkedIMPSTransaction = async () => {
  //   try {
  //     // IMPS Transaction body
  //     const impsTransactionData = {
  //       customerId: '123',
  //       customerNameFromFrontEnd: 'Resham',
  //       customerMobile: '88888888888',
  //       projectId: '123',
  //       points: '6000',
  //       bankId: '89869696969',
  //       method: 'Bank',
  //     };

  //     console.log('impsTransactionData: ', impsTransactionData);
  //     // Set a minimum loader time of 3 seconds
  //     const minimumLoaderTime = new Promise((resolve) =>
  //       setTimeout(resolve, 3000)
  //     );

  //     setAadhaarFlowLoading(true);
  //     setIsDisabled(true);

  //     const [response] = await Promise.all([
  //       (impsTransactionData),
  //       minimumLoaderTime,
  //     ]);

  //     if (response.success) {
  //       // console.log('response ', response);
  //       setTransactionDetails(response.transactions);
  //       handleClose();
  //       // console.log('Onsuccess executed...');
  //       onSuccess();
  //     } else {
  //       if (response.message) {
  //         // console.log('response.message: ', response.message);
  //         toast.error(response.message, { style: { color: 'red' } });
  //         setTransactionStatusToastMessage(response.message);
  //         handleClose();
  //       } else {
  //         toast.error('Something went wrong.');
  //         setTransactionStatusToastMessage('Something went wrong.');
  //         handleClose();
  //       }
  //     }
  //   } catch (error) {
  //     if (error?.message) {
  //       console.error('error.message: ', error.message);
  //       toast.error(error.message, { style: { color: 'red' } });
  //       setTransactionStatusToastMessage(error.message);
  //     } else {
  //       console.error('error: ', error);
  //       toast.error('Something went wrong.');
  //       setTransactionStatusToastMessage('Something went wrong.');
  //       handleClose();
  //     }
  //   } finally {
  //     setAadhaarFlowLoading(false);
  //     setIsDisabled(false); // End the loading state
  //   }
  // };

  // const aadhaarNotlinkedRedeemptionFlow = async () => {
  //     if (selectedMethod === 'bank') {
  //       await handleNoAadhaarLinkedIMPSTransaction();
  //     }
  //     if (selectedMethod === 'upi') {
  //       await handleNoAadhaarLinkedUPITransaction();
  //     }
  //   };

  // const handleNoAadhaarLinkedUPITransaction = async () => {
  //   // console.log('handleUPITransaction called...');
  //   try {
  //     if (!isValidUPI(upiId)) {
  //       // setErrors((prevErrors) => ({
  //       //   ...prevErrors,
  //       //   upi: 'Error: Please enter a valid UPI ID.',
  //       // }));
  //       toast.error('Please enter a valid UPI ID.');
  //       return;
  //     }
  //     const upiTransactionData = {
  //       customerId:'1',
  //       customerNameFromFrontEnd: 'Resham',
  //       customerMobile: '8888888888',
  //       points: '60000',
  //       upiId: 'xyz@oksbi',
  //       projectId: '123',
  //       method: 'upi',
  //     };
  //     console.log('upiTxnData', upiTransactionData);

  //     //       customerId :12639
  //     // customerName : "HARSHADA"
  //     // points : 1000
  //     // projectId : 53
  //     // upiId : "95harshada@ybl"

  //     // console.log('upiTransactionData: ', upiTransactionData);
  //     // Set a minimum loader time of 3 seconds
  //     const minimumLoaderTime = new Promise((resolve) =>
  //       setTimeout(resolve, 3000)
  //     );

  //     setIsDisabled(true);

  //     const [response] = await Promise.all([
  //       (upiTransactionData),
  //       minimumLoaderTime,
  //     ]);

  //     // const [response] = await Promise.all([
  //     //   processRedeemPointsUPITransaction(upiTransactionData),
  //     //   minimumLoaderTime,
  //     // ]);
  //     // console.log('response=====.....>>>>', response);

  //     if (response.success) {
  //       // console.log('response ', response);
  //       setTransactionDetails(response.transactions);
  //       handleClose();
  //       // console.log('Onsuccess executed...');
  //       onSuccess();
  //     } else {
  //       console.log('---> CATCH 1 called.....');

  //       if (response.message) {
  //         if (response.message === 'UPI ID or Name Verification Failed.') {
  //           setDisplayNameMismatchModal(true);
  //           console.log(
  //             'error.message MATCHED THE NAME VERIFICATION MESSAGE...'
  //           );
  //         }
  //         // console.log('response.message: ', response.message);
  //         toast.error(response.message, { style: { color: 'red' } });
  //         setTransactionStatusToastMessage(response.message);
  //         handleClose();
  //       } else {
  //         toast.error('Something went wrong.');
  //         setTransactionStatusToastMessage('Something went wrong.');
  //         handleClose();
  //       }
  //     }
  //   } catch (error) {
  //     console.error('error ----> ', error);
  //     // console.log(' error?.bankVerifiedName ----> ', error?.bankVerifiedName);
  //     console.log('---> CATCH 2 called.....');

  //     if (error.message === 'UPI ID or Name Verification Failed.') {
  //       setCustomerNameAsPerBankUPI(error?.bankVerifiedName);
  //       setDisplayNameMismatchModal(true);
  //       console.log('error.message MATCHED THE NAME VERIFICATION MESSAGE...');
  //     } else {
  //       toast.error(error.message, { style: { color: 'red' } });
  //       setTransactionStatusToastMessage(error.message);
  //     }
  //   }
  // };

  //    const handleAadhaarModalProceed = async () => {
  //   setAadhaarFlowLoading(true);
  //   try {
  //     await aadhaarNotlinkedRedeemptionFlow();
  //     setShowAadhaarModal(false);
  //   } catch (err) {
  //     console.error(err);
  //   } finally {
  //     setAadhaarFlowLoading(false);
  //   }
  // };

  const handleAccountInputChange = (e) => {
    const { name, value } = e.target;
    // console.log(name, value ,'e. target valueeeeee========>')
    const newValue = name === "ifsc" ? value.toUpperCase() : value;
    setAccountData((prev) => ({ ...prev, [name]: newValue }));
  };


  const handleAddAccountSubmit = async () => {
    console.log(
      "--------------------handleAddAccountSubmit called--------------------------"
    );

    // e.preventDefault();
    // console.log("eeeeeeeeeeee=====>>>>>>>>>>>>>>>>", e.target.value);
    // console.log("accountData ====================>", accountData);

    setAddBankAccountLoading(true);
    try {
      // const addAccount = await addFosBankAccount(accountData);
      // ------------------------------------
      const payload = {
        id_number: accountData.accountNumber,
        ifsc: accountData.ifsc,
        fos_id: fosId,
        user_name: name,
        bank_name: accountData.bankName,
        branch_name: accountData.branchName,
      };
      const response = await axios.post(
        "https://vjoneparivaar.com/api/fosWallet/addFOSBankAccount",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      //-------------------------------------
      console.log("add account RESPONSE -----> ", response);
      setAccountData({
        accountNumber: "",
        ifsc: "",
        bankName: "",
        branchName: "",
        upiId: "",
      });
      await getFosBankAccountsByFosUUID();
      setShowAddAccountModal(false);

      if (response?.data && response?.data?.status === "verified") {
        // setStatus(addAccount.msg);
        toast.success("Account verified and added successfully");
      } else {
        console.log("ELSE BLOCK EXECUTED----------------------->");
        if (
          response?.data?.Msg ===
          "Your bank account name does not match with your property details"
        ) {
          console.log(
            "--------------------------NAME MISMATCH ERROR MATCHED-------------------------"
          );
        } else {
        }
      }
    } catch (err) {
      setAccountData({
        accountNumber: "",
        ifsc: "",
        bankName: "",
        branchName: "",
        upiId: "",
      });
      console.error("Error occurred ===============>:", err);
      console.error("err?.response?.data", err?.response?.data?.msg);
      if (
        err?.response?.data?.msg ===
        "Your bank account name does not match with VJ database"
      ) {
        console.log(
          "--------------------------NAME MISMATCH ERROR MATCHED-------------------------"
        );
        setNameAsPerBankUPI(err?.response?.data?.nameAsPerBankUPI);
        setNameMismatchModal(true);
      } else {
        if (err?.response?.data?.msg) {
          toast.error(err?.response?.data?.msg);
        } else {
          toast.error("Something went wrong while adding your bank account.");
        }
      }
    } finally {
      setAddBankAccountLoading(false);
    }
  };

  const handleUpiChange = (e) => {
    // console.log(e.target.value);
    setUpiId(e.target.value);
    // setSelectedMethod('upi');
    // setSelectedCard({ account_number: '' });
  };

  //  const isValidUPI = (upi) => {
  //   const pattern = /^[a-zA-Z0-9.\-_]{2,}@[a-zA-Z0-9]+$/;
  //   // console.log('upi received: ', upi);
  //   return pattern.test(upi);
  // };

  const fosReedemPointsUpiTransaction = async () => {
    try {
      const payload = {
        fosId: fosId,
        fosName: name,
        fosMobile: "8888888888",
        points: fosFinalReedemableBalance,
        upiId: upiId,
      };
      const response = await axios.post(
        "https://vjoneparivaar.com/api/fosWallet/fosRedeemPointsUPITransaction",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // console.log("response==========>",response)
      // console.log("response==========1>",response?.data)
      // console.log("response==========2>",response?.data?.data)

      if (response?.data?.success) {
        console.log("enter in sucess");
        // console.log('response ', response);
        // setTransactionDetails(response.transactions);
        // handleClose();
        // console.log('Onsuccess executed...');
        // onSuccess();
        // console.log("response?.data?.transactions ===================> ", response?.data?.transactions)
        setTransactionDetails(response?.data?.transactions);
        setShowStatusModal(true);

        // toast.error(response.data.message, { style: { color: 'green' } })
      } else {
        if (response?.data?.data?.message) {
          console.log("console number 1");
          // console.log('response.message: ', response.message);
          toast.error(response.data.data.message, { style: { color: "red" } });
          // setTransactionStatusToastMessage(response.message);
          // handleClose();
        } else {
          console.log("console number 2");
          toast.error("Something went wrong.");
          // setTransactionStatusToastMessage('Something went wrong.');
          // handleClose();
        }
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        console.log("console number 3");
        // It's an Axios error
        const errorMessage =
          error.response?.data?.message || "An error occurred";
        toast.error(errorMessage);
      } else {
        console.log("console number 4");
        // Non-Axios error (programm
        // ing error, etc)
        toast.error("Unexpected error: " + error.message);
      }
    }
  };

  const fosReedemPointsIMPSTransaction = async () => {
    try {
      const selectedAccount = savedAccounts[selectedAccountIndex];
      console.log("saved account", savedAccounts);
      const payload = {
        fosId: fosId,
        fosName: name,
        fosMobile: "8888888888",
        points: fosFinalReedemableBalance,
        fosBankId: selectedAccountIndex,
      };
      // const response=await axios.post("/fosWallet/fosRedeemPointsIMPSTransaction", payload);
      const response = await axios.post(
        "https://vjoneparivaar.com/api/fosWallet/fosRedeemPointsIMPSTransaction",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      // console.log("response==========>",response)
      // console.log("response==========1>",response?.data)
      // console.log("response==========2>",response?.data?.data)

      // return response
      if (response?.data?.success) {
        console.log("enter in sucess");
        // console.log('response ', response);
        // setTransactionDetails(response.transactions);
        // handleClose();
        // console.log('Onsuccess executed...');
        // onSuccess();

        setTransactionDetails(response?.data?.transactions);
        setShowStatusModal(true);

        // toast.error(response.data.message, { style: { color: 'green' } })
      } else {
        if (response?.data?.data?.message) {
          console.log("console number 1");
          // console.log('response.message: ', response.message);
          toast.error(response.data.data.message, { style: { color: "red" } });
          // setTransactionStatusToastMessage(response.message);
          // handleClose();
        } else {
          console.log("console number 2");
          toast.error("Something went wrong.");
          // setTransactionStatusToastMessage('Something went wrong.');
          // handleClose();
        }
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        console.log("console number 3");
        // It's an Axios error
        const errorMessage =
          error.response?.data?.message || "An error occurred";
        toast.error(errorMessage);
      } else {
        console.log("console number 4");
        // Non-Axios error (programm
        // ing error, etc)
        toast.error("Unexpected error: " + error.message);
      }
    }
  };

  const handleSuccessModalClose = () => {
    // handleGetFinalRedeemableBalance(currentUnit.BUId, userId);
    // getWalletBalance(userId);
    // getWalletTransactions(userId);
    setShowStatusModal(false);
  };
  const handleNameMismatchModal = () => {
    setNameMismatchModal(false);
  };




 const axiosInstance = axios.create({
    baseURL,
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });

  const getFosBankAccountsByFosUUID = async () => {
    console.log("inside getFosBankAccountsByFosUUID");
    try {
      const fos_id = fosId;
      const response = await axiosInstance.get(
        `/foswallet/getFosBankAccountsByFosUUID?fos_id=${fos_id}`
      );
      // console.log('responce of  ',response?.data?.data)
      setFosBankAccountsByFos(response?.data?.data);
    } catch (error) {
      console.error("FOS API getFosDetails error:", error);
      if (error.response?.data) throw error.response.data;
      throw error;
    }
  };
  useEffect(() => {
    getFosBankAccountsByFosUUID();
  }, []);

  const handleSelectedMethod = async (method) => {
    setSelectedMethod(method);
    await getfosFinalReedemableBalance();
  };

  useEffect(() => {
    if (open) {
      setSelectedMethod("upi");

      setSelectedAccountIndex(null);
      setIsSuccess(null);
      setIsProcessing(false);
      setUpiId("");
    }
  }, [open]);

 




const handleRedeem = async () => {
  if (!selectedMethod) {
    toast.error("Please select a redeem method.");
    return;
  }
  if (selectedMethod === "bank" && (!fosBankAccountsByFos || selectedAccountIndex === null)) {
    toast.error("Please select a bank account.");
    return;
  }
  if (selectedMethod === "upi" && !upiId.trim()) {
    toast.error("Please enter a valid UPI ID.");
    return;
  }

  setIsProcessing(true);
  try {
    const response = await axios.post(`${baseURL}/fosWallet/fosPreRedeemtionPanVerification`, {
      fosId,
      fosNameFromFrontEnd: name,
      points: fosFinalReedemableBalance,
      method: selectedMethod,
      upiId,
      fosBankId: selectedAccountIndex,
      fosMobile:contactNumber ? contactNumber.toString() : ""
    });


    const { status, body } =  response.data;
    const {aadhaarLinked,transactions,message} = body
    console.log('body', body)
    console.log('aadhaarLinked', aadhaarLinked)
    console.log('message', message)
      if ( aadhaarLinked === false || message === "Aadhaar is NOT linked with this PAN. TDS will be 20%." ) {
        // Aadhaar not linked — trigger Aadhaar modal flow
        console.log("in 2nd if ")
        setShowAadhaarModal(true);
        // onClose()
        return
      }
    if (status === 200 || body.success) {
      // Aadhaar linked — complete redemption
      setTransactionDetails(transactions);
      setShowStatusModal(true);
      onClose();
    } else {
      toast.error("PAN verification failed.");
    }
  } catch (err) {
    const msg = err?.response?.data?.message || "PAN Verification failed.";
    toast.error(msg);
    if (err.response.data.message === 'Invalid PAN' || err.response.status === 422){
    setShowPanErrorModal(true)
    }
  } finally {
    setIsProcessing(false);
  }
};






const handleAadhaarModalProceed = async () => {
  setAadhaarFlowLoading(true);
  try {
    await aadhaarNotlinkedRedeemptionFlow();
    setShowAadhaarModal(false);
  } catch (err) {
    toast.error("Redemption failed. Try again.");
  } finally {
    setAadhaarFlowLoading(false);
  }
};



const aadhaarNotlinkedRedeemptionFlow = async () => {
  if (selectedMethod === "bank") {
    await handleNoAadhaarLinkedIMPSTransaction();
  } else {
    await handleNoAadhaarLinkedUPITransaction();
  }
};




const handleNoAadhaarLinkedIMPSTransaction = async () => {
  try {
    const payload = {
      fosId,
      fosMobile: contactNumber ? contactNumber.toString() : "",
      fosNameFromFrontEnd: name,
      method: "bank",
      points: fosFinalReedemableBalance,
      fosBankId: selectedAccountIndex,
    };

    const response = await axios.post(`${baseURL}/fosWallet/fosRedeemPointsCaller`, payload);

    if (response.data?.body?.success && response.data?.status ===200) {
      setTransactionDetails(response.data?.body?.transactions);
      setShowStatusModal(true);
      onSuccess?.();
      onClose();
    } else {
      const msg = response?.data?.body?.message || "Something went wrong.";
      toast.error(msg);
      setTransactionStatusToastMessage(msg);
      onClose();
    }
  } catch (err) {
    const msg = err?.response?.data?.body?.message || err.message || "Unexpected error.";
    toast.error(msg);
    setTransactionStatusToastMessage(msg);
  } finally {
    setAadhaarFlowLoading(false);
    setIsDisabled(false);
  }
};



const handleNoAadhaarLinkedUPITransaction = async () => {
  try {
    const payload = {
      fosId,
      fosMobile: contactNumber ? contactNumber.toString() : "",
      fosNameFromFrontEnd: name,
      method: "upi",
      points: fosFinalReedemableBalance,
      upiId: upiId  // fallback
    };

    const response = await axios.post(`${baseURL}/fosWallet/fosRedeemPointsCaller`, payload);

    if (response.data?.body?.success && response.data?.status ===200) {
      setTransactionDetails(response.data.body.transactions);
      setShowStatusModal(true);
    } else {
      const msg = response.data.message || "Something went wrong.";
      toast.error(msg);
      setTransactionStatusToastMessage(msg);
    }
  } catch (err) {
    const msg = err?.response?.data?.message || err.message || "Unexpected error.";
    toast.error(msg);
    setTransactionStatusToastMessage(msg);
  } finally {
    setAadhaarFlowLoading(false);
  }
};



  return (
    <>
      <Modal open={open} onClose={onClose}>
        <Box sx={modalStyle}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography
              variant="h5"
              fontWeight="bold"
              color="primary"
              sx={{ fontSize: isMobile ? "2.3rem" : "2.3rem" }}
            >
              Withdraw Your Reward Points
            </Typography>
            {/* <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton> */}
            <IconButton onClick={onClose}>
              <CloseIcon sx={{ fontSize: "2.5rem" }} />
            </IconButton>
          </Box>

          {/* Method Selection */}
          <Typography
            sx={{ fontSize: "1.7rem", color: "text.secondary", mb: 2 }}
          >
            Choose your preferred method to redeem your points
          </Typography>

          <Grid container spacing={2} mb={2}>
            <Grid item xs={6}>
              <Button
                fullWidth
                variant="outlined"
                onClick={() => handleSelectedMethod("bank")}
                startIcon={<AccountBalanceIcon />}
                sx={{
                  borderColor:
                    selectedMethod === "bank" ? "#1976d2" : "grey.400",
                  bgcolor:
                    selectedMethod === "bank" ? "#e3f2fd" : "transparent",
                  color: selectedMethod === "bank" ? "#1976d2" : "inherit",
                  fontSize: "1.2rem",
                  py: 1.2,
                }}
              >
                Bank Account
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                fullWidth
                variant="outlined"
                onClick={() => handleSelectedMethod("upi")}
                startIcon={<AttachMoneyIcon />}
                sx={{
                  borderColor:
                    selectedMethod === "upi" ? "#1976d2" : "grey.400",
                  bgcolor: selectedMethod === "upi" ? "#e3f2fd" : "transparent",
                  color: selectedMethod === "upi" ? "#1976d2" : "inherit",
                  fontSize: "1.2rem",
                  py: 1.2,
                }}
              >
                UPI ID
              </Button>
            </Grid>
          </Grid>

         
          {selectedMethod === "bank" && fosBankAccountsByFos?.length > 0 && (
            <Paper variant="outlined" sx={{ bgcolor: "#f6f9fc", p: 2, mb: 2 }}>
              <Typography sx={{ fontSize: "1.7rem", fontWeight: 600, mb: 1 }}>
                Your Bank Accounts
              </Typography>
              <Box
                sx={{
                  maxHeight: 300,
                  overflowY: "auto",
                  pr: 1,
                }}
              >
                {fosBankAccountsByFos.map((acc, index) => {
                  if (
                    !acc?.account_number ||
                    acc.account_number.trim() === "" ||
                    !acc?.IFSC_code ||
                    acc.IFSC_code.trim() === ""
                  ) {
                    return null; // Skip rendering this card
                  }

                  const isSelected = selectedAccountIndex === acc.id;

                  return (
                    <Box
                      key={index}
                      onClick={() => setSelectedAccountIndex(acc.id)}
                      sx={{
                        borderRadius: 3,
                        p: 3,
                        mb: 2,
                        background: isSelected
                          ? "linear-gradient(135deg, #eaf1fe, #b3d4ff, #1669F2)"
                          : "linear-gradient(135deg, #f0f4fa, #d9e2f3, #a3bffa)",
                        color: isSelected ? "#000" : "#555",
                        fontFamily: "'Poppins', sans-serif",
                        boxShadow: isSelected
                          ? "0 6px 20px rgba(22, 105, 242, 0.5)"
                          : "0 4px 12px rgba(0,0,0,0.1)",
                        cursor: "pointer",
                        userSelect: "none",
                        border: isSelected
                          ? "3px solid #1669F2"
                          : "3px solid transparent",
                        transition: "all 0.3s ease",
                        display: "flex",
                        alignItems: "flex-start",
                        "&:hover": {
                          boxShadow: "0 6px 18px rgba(22, 105, 242, 0.4)",
                        },
                      }}
                    >
                      <Checkbox
                        checked={isSelected}
                        onChange={() => setSelectedAccountIndex(acc.id)}
                        icon={
                          <RadioButtonUncheckedIcon sx={{ fontSize: 30 }} />
                        }
                        checkedIcon={
                          <CheckCircleOutlineIcon
                            sx={{ fontSize: 30, color: "#1669F2" }}
                          />
                        }
                        sx={{ p: 0, mr: 2 }}
                        onClick={(e) => e.stopPropagation()} // Prevent click bubbling
                        size="large"
                      />
                      <Box>
                        <Typography sx={{ fontSize: "1.8rem", opacity: 0.85 }}>
                          Account number
                        </Typography>
                        <Typography
                          sx={{ fontSize: "1.8rem", fontWeight: 700, mb: 1 }}
                        >
                          {acc.account_number}
                        </Typography>
                        <Typography sx={{ fontSize: "1.8rem", opacity: 0.85 }}>
                          IFSC code
                        </Typography>
                        <Typography
                          sx={{ fontSize: "1.8rem", fontWeight: 600 }}
                        >
                          {acc.IFSC_code}
                        </Typography>
                      </Box>
                    </Box>
                  );
                })}
              </Box>
            </Paper>
          )}

          {selectedMethod === "bank" && (
            <Box
              mt={1}
              py={1.5}
              px={2}
              textAlign="center"
              sx={{
                border: "1px dashed #1976d2",
                borderRadius: 1,
                cursor: "pointer",
                color: "#1976d2",
                fontSize: "1.2rem",
              }}
              onClick={() => setShowAddAccountModal(true)}
            >
              <AddIcon fontSize="small" />
              <Typography component="span" sx={{ fontSize: "1.9rem" }}>
                &nbsp;Add new account
              </Typography>
            </Box>
          )}

          {selectedMethod === "upi" && (
            <Paper variant="outlined" sx={{ bgcolor: "#f6f9fc", p: 2, mb: 2 }}>
              <Typography sx={{ fontSize: "2rem", fontWeight: 600, mb: 1 }}>
                Enter your UPI ID
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="example@upi"
                name="upiId"
                value={upiId}
                onChange={handleUpiChange}
                InputProps={{
                  sx: {
                    fontSize: "2rem", // typed text font size increased
                    "&::placeholder": {
                      fontSize: "2rem", // placeholder font size increased
                      fontWeight: 600,
                      opacity: 0.7, // subtle placeholder
                    },
                  },
                }}
              />
            </Paper>
          )}

          <Paper variant="outlined" sx={{ bgcolor: "#f6f9fc", p: 2, mb: 2 }}>
            <Box display="flex" justifyContent="space-between" py={1}>
              <Typography sx={{ fontSize: "2rem" }}>
                Your Balance (1 Point = ₹1)
              </Typography>
              <Typography fontWeight="bold" sx={{ fontSize: "2rem" }}>
                {fosFinalReedemableBalance.toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                })}
              </Typography>
            </Box>
          </Paper>

          <Button
            variant="contained"
            sx={{
              backgroundColor: "#1976D2",
              color: "#fff",
              width: "100%",
              mb: 2,
              px: 4,
              py: 1.8,
              fontSize: "1.3rem",
            }}
            disabled={
              fosFinalReedemableBalance === 0 ||
              isProcessing ||
              !selectedMethod ||
              (selectedMethod === "bank" && selectedAccountIndex === null) ||
              (selectedMethod === "upi" && !upiId?.trim())
            }
            onClick={handleRedeem}
          >
            {isProcessing ? (
              <CircularProgress size={26} sx={{ color: "#fff" }} />
            ) : (
              "Confirm and Redeem"
            )}
          </Button>

          <Typography sx={{ fontSize: "1.9rem", textAlign: "center",color: "text.secondary" }}>
            Amount will be credited within 48 hours
          </Typography>

          <Typography
            sx={{
              fontSize: "1.6rem",
              textAlign: "center",
              mt: 1,
              color: "red",
            }}
          >
            Having trouble with payment?{" "}
            <Box
              component="span"
              sx={{
                color: "blue",
                textDecoration: "underline",
                cursor: "pointer",
                display: "inline",
              }}
              onClick={() => setShowTroubleModal(true)}
            >
              Click here
            </Box>
          </Typography>
        </Box>
      </Modal>

      {/* Add Account Modal */}
     <AddBankAccountModal
  open={showAddAccountModal}
  onClose={() => setShowAddAccountModal(false)}
  accountData={accountData}
  onChange={handleAccountInputChange}
  onSubmit={handleAddAccountSubmit}
  loading={addBankAccountLoading}
/>


      {/* Trouble Modal */}
      <TroubleInPayment
        open={showTroubleModal}
        handleClose={() => setShowTroubleModal(false)}
        transactionStatusToastMessage={"Issue during withdrawal attempt."}
      />

      <TransactionStatusModal
        open={showStatusModal}
        handleClose={handleSuccessModalClose}
        transactionDetails={transactionDetails}
      />
      <RedeemNameMismatchModal
        fosName={name}
        bankVerifiedName={nameAsPerBankUPI}
        open={nameMismatchModal}
        handleClose={handleNameMismatchModal}
      />

      <AadhaarTDSWarningModal
        open={showAadhaarModal}
        isLoading={aadhaarFlowLoading}
        onClose={() => setShowAadhaarModal(false)}
        onProceed={handleAadhaarModalProceed}
      />

      {showPanErrorModal && (
        <Suspense fallback={<CircularProgress />}>
          <PanErrorModal
            open={true}
            message={panErrorMessage}
            onClose={() => setShowPanErrorModal(false)}
          />
        </Suspense>
      )}

   
    </>
  );
};

export default WithdrawPointsModal;
